import React from 'react'
import formatDate from '../../../../../../utils/formatDate'

const JobSeekerCertification = ({ data }) => {
  return (
    <div className="candidate-profile my-3 border rounded border-primary">

      <div className="work-experience">
        <div>
          <h5 className="designation">{data["name"]}</h5>
          <p className="company-location">
            <b>Organization: {data["organization"]}</b>
          </p>
          <p className="company-location">
            Issued on: {formatDate(data["issue_date"])}
          </p>
          {data["expiry_date"] && (
            <p className="company-location">
              Expiry: {formatDate(data["expiry_date"])}
            </p>
          )}
        </div>
      </div>

    </div>
  )
}

export default JobSeekerCertification